import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// import useChecklist from '../../hooks/useChecklist';
import useAuth from "../../hooks/useAuth";

import Screen from "../../components/Screen";
import SubmitButton from "../../components/SubmitButton";
import NewOptions from "./NewOptions";
import ReviewButtons from "./ReviewButtons";
import RiskAssesmentDetails from "./riskAssesmentDetails";
import RiskAssesmentQuestions from "./riskAssesmentQuestions";
import appContext from "../../app/contextState/context";
import { RiskAssesmentContext } from "../../hooks/riskAssesmentContext";
import AlertSetup from "./alertSetup";

const NewRiskAssesment = () => {
  //('hi')
  const location = useLocation();
  const { isAdmin } = useAuth();
  const state = useContext(appContext);
  const { loading } = state;
  const {
    collection,
    data,
    question,
    setData,
    setQuestion,
    fetchRiskAssesments,
    onAddQuestiuon,
    newRiskAssesment,
    changeRiskAssesment,
    removeRiskAssesment,
    sendForReview,
    approveReview,
    rejectReview,
    onDublicateQuestiuon
  } = useContext(RiskAssesmentContext);

  // states
  const [showQuestions, setShowQuestions] = useState(false);
  const [showReportSetup, setShowReportSetup] = useState(false);

  const update = location?.search.split("?update=")[1];
  // Constants
  const riskAssesmentID = location.state?.data?._id;
  const disabled =
    // data?.questions?.length == 0 ||
    !data?.title || !data?.riskAssesmentFrequency || !data?.categoryID;

  useEffect(() => {
    if (riskAssesmentID) fetchRiskAssesments({ id: riskAssesmentID });
  }, []);

  useEffect(() => {
    if (loading != "fetch" && location.state?.data) {
      setData(collection?.find((item) => item?._id == riskAssesmentID));
    }
  }, [update]);

  useEffect(() => {
    if (!location.state?.data) {
      setData({
        title: "",
        riskAssesmentFrequency: "Daily",
        riskAssesmentReport: "None",
        notificationFrequency: { date: Date.now(), times: [Date.now()] },
        reportFrequency: { date: Date.now(), times: [Date.now()] },
        questions: [],
      });
    }
  }, [update]);

  return (
    <Screen
      loading={loading == "fetch"}
      faqsId={"add_risk_assessments"}
      flow={[
        { label: "Risk Assessment", to: "/risk assesment" },
        { label: "Home", to: "/risk-assesments" },
        { label: "Collection", to: "/risk-assesments" },
        {
          label: !!location.state?.data ? "Update Risk Assessment" : "New Risk Assessment",
          to: "/new-risk-assesment",
        },
      ]}
    >
      {location?.state == null ? (
        <NewOptions />
      ) : (
        <section className="section profile">
          <div className="row">
            <form action="" className="row">
              {/* Submit Button */}
              <div className="d-flex justify-content-end mb-3 gap-3">
                {!showQuestions && !showReportSetup ? null : (
                  <SubmitButton
                    title={"Back"}
                    onClick={() => {
                      setShowQuestions(false)
                      setShowReportSetup(false)
                    }}
                    color={"outline-primary"}
                    icon={<i className="bi bi-arrow-left "></i>}
                  />
                )}
                {data?.companyID && (
                  <ReviewButtons
                    loading={loading}
                    data={data}
                    sendForReview={sendForReview}
                    rejectReview={rejectReview}
                    approveReview={approveReview}
                  />
                )}
                {isAdmin && data?.status == "pending" ? null : (
                  <>
                    <SubmitButton
                      title={"Save"}
                      loading={loading == "new" || loading == "update"}
                      onClick={() =>
                        location.state?.update
                          ? changeRiskAssesment()
                          : newRiskAssesment()
                      }
                      color={"success"}
                      loaderColor={"white"}
                      disabled={disabled}
                    />
                    {!location.state?.data ? null : (
                      <SubmitButton
                        icon={<i className="bi bi-trash3"></i>}
                        loading={loading == "delete"}
                        onClick={() => removeRiskAssesment()}
                        color={"danger"}
                        loaderColor={"white"}
                        disabled={disabled}
                      />
                    )}
                  </>
                )}
              </div>
              {showQuestions || showReportSetup ? null : (
                <RiskAssesmentDetails data={data} setData={setData} />
              )}
              {!showReportSetup ? null : (
                <AlertSetup data={data} setData={setData} />
              )}
              {showReportSetup || showQuestions ? null : (
                <div
                  className="d-flex justify-content-center align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowQuestions(false)
                    setShowReportSetup(true)
                  }}
                >
                  <span className="card-title text-center">Setup Report</span>
                  <i className="bi bi-arrow-right card-title text-center"></i>
                </div>
              )}
              {showQuestions || showReportSetup ? null :(
                <div
                  className="d-flex justify-content-center align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowQuestions(true)}
                >
                  <span className="card-title text-center">View Questions</span>
                  <i className="bi bi-arrow-right card-title text-center"></i>
                </div>
              )}
              {!showQuestions ? null : (
                <RiskAssesmentQuestions
                  data={data}
                  setData={setData}
                  question={question}
                  setQuestion={setQuestion}
                  onAddQuestiuon={onAddQuestiuon}
                  onDublicateQuestiuon={onDublicateQuestiuon}
                />
              )}
            </form>
          </div>
        </section>
      )}
    </Screen>
  );
};

export default NewRiskAssesment;
